import { Add as AddIcon } from "@mui/icons-material";
import { Box, Grid, IconButton, Stack } from "@mui/material";
import { isNil, orderBy } from "lodash";
import type { FC } from "react";
import type { ID } from "../../data/BaseEntity";
import { removeArr, updateArr } from "../../misc/utils";
import ProductOption from "./ProductOption";

const AddOptionButton: FC<{ disabled: boolean; onClick: () => void }> = ({ disabled, onClick }) => (
  <IconButton aria-label="Dodaj opcję" disabled={disabled} onClick={onClick}>
    <AddIcon />
  </IconButton>
);

export interface AvailableOption {
  id: string;
  name: string;
}

interface Props {
  productId: string | undefined;
  selectedOptions: (ID | null)[];
  availableOptions: AvailableOption[];
  readonly?: boolean;
  onChange: (options: (ID | null)[]) => void;
}

const ProductOptions: FC<Props> = ({ productId, selectedOptions, availableOptions, onChange }) => {
  const editDisabled = isNil(productId);
  const options = availableOptions.map((o) => ({
    label: o.name,
    value: o.id,
  }));
  const orderedOptions = orderBy(options, (o) => o.label.toLowerCase());

  const updateOption = (optionIdx: number, optionId: ID) => {
    onChange(updateArr(selectedOptions, optionIdx, optionId));
  };

  return (
    <Stack direction="row" spacing={1}>
      <Box
        sx={{
          flexShrink: 0,
          flexGrow: 0,
        }}
      >
        <AddOptionButton disabled={editDisabled} onClick={() => onChange([...selectedOptions, null])} />
      </Box>
      <Grid
        container
        sx={{
          flexGrow: 1,
        }}
      >
        {selectedOptions.map((option, optionIdx) => (
          <Grid key={optionIdx} size={{ xs: 12, lg: 6 }} container>
            <ProductOption
              value={option}
              options={orderedOptions}
              onChange={(id) => updateOption(optionIdx, id)}
              onDelete={() => onChange(removeArr(selectedOptions, optionIdx))}
            />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default ProductOptions;
